// Textos del programa de referidos (referrals). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'en',
  data: {
    REFERRALS: {
      ACTIONS: {
        RELOAD: 'Reload',
        LOADING: 'Loading...',
        NEW_LINK: 'New link',
        APPLY: 'Apply',
        RETRY: 'Retry',
        LINK: 'Link',
        VIEW_LINKS: 'View links',
        SAVE: 'Save',
        SAVING: 'Saving…',
        CANCEL: 'Cancel',
        BONUS: 'Bonus',
        ACTIVATE: 'Activate',
        DEACTIVATE: 'Deactivate',
        ACTIVATING: 'Activating…',
        DEACTIVATING: 'Deactivating…',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        FIRST_PAGE: 'First page',
        LAST_PAGE: 'Last page',
        CHANGE: 'Change',
        CLOSE: 'Close',
        CREATE_LINK: 'Create link',
        CREATING: 'Creating...',
      },
      RANGE: {
        ARIA: 'Period',
        DAYS: '{{n}} days',
        ALL: 'All',
        FROM: 'From',
        TO: 'To',
      },
      FUNNEL: {
        ARIA: 'Referrals funnel',
        LOADING: 'Loading funnel',
        REDEEMED: 'Redemptions',
        REGISTERED: 'Registered',
        COMPLETED: 'Completed',
        CONV_TOOLTIP: 'Of the previous stage',
        LINKS_CREATED_ONE: 'link created',
        LINKS_CREATED_OTHER: 'links created',
        PAID: 'paid',
        REDEMPTIONS_ONE: '{{n}} redemption',
        REDEMPTIONS_OTHER: '{{n}} redemptions',
        DEFAULT_PREFIX: 'Default:',
        DEFAULT_SUFFIX: 'per party',
      },
      STATUS: {
        TITLE: 'Current status of redemptions',
        HINT: 'The cohort is based on redemption date and the status is as of today. Amounts paid are measured by payment date.',
        PENDING_REGISTRATION: 'Pending registration',
        REGISTERED_UNPAID: 'Registered, not yet paid',
        COMPLETED: 'Completed',
        EXPIRED: 'Expired',
      },
      OWNERS: {
        TITLE: 'Referrers',
        SUBTITLE: 'Users who have generated invitation links. Click “View links” to see and edit their links.',
        SEARCH_PLACEHOLDER: 'Search referrer by first name, last name or email',
        SEARCH_ARIA: 'Search referrers',
        CLEAR_SEARCH: 'Clear search',
        ONLY_WITH_REDEMPTIONS: 'Only with redemptions',
        LOADING: 'Loading referrers',
        EMPTY: 'Nobody has generated an invitation link yet.',
        COL_OWNER: 'Referrer',
        COL_LINKS: 'Links',
        COL_REDEMPTIONS: 'Redemptions',
        COL_PENDING: 'Pending',
        COL_REGISTERED: 'Registered',
        COL_COMPLETED: 'Completed',
        COL_EXPIRED: 'Expired',
        COL_PAID: 'Paid',
        COL_LAST_LINK: 'Last link',
        COL_ACTIONS: 'Actions',
        ACTIVE_COUNT_ONE: '{{n}} active',
        ACTIVE_COUNT_OTHER: '{{n}} active',
        PAGINATION_ONE: 'Showing {{shown}} of {{total}} referrer',
        PAGINATION_OTHER: 'Showing {{shown}} of {{total}} referrers',
        ROWS_PER_PAGE: 'Rows per page',
        ROWS_PER_PAGE_OPTION: '{{n}} rows',
      },
      LINKS: {
        LOADING: 'Loading links...',
        EMPTY: 'This user has no links.',
        ACTIVE: 'Active',
        INACTIVE: 'Deactivated',
        CAMPAIGN: 'Campaign',
        CREATED_ON: 'Created on {{date}}',
        COPY: 'Copy link',
        COPIED: 'Link copied',
        REDEMPTIONS_ONE: 'redemption',
        REDEMPTIONS_OTHER: 'redemptions',
        PENDING_SHORT: '{{n}} pend.',
        REGISTERED_SHORT: '{{n}} reg.',
        COMPLETED_SHORT: '{{n}} compl.',
        EXPIRED_SHORT: '{{n}} exp.',
        PAGER_SHOWING: 'Showing',
        PAGER_OF: 'of',
        PAGER_LINKS_ONE: 'link',
        PAGER_LINKS_OTHER: 'links',
        NOTE: 'Changing the bonus only affects new redemptions: anyone who has already redeemed is paid what they were promised. Deactivating a link stops new redemptions and lets the ones already in progress continue.',
      },
      BONUS: {
        REFERRED: 'Invitee',
        OWNER: 'Referrer',
        REFERRED_EUR: 'Invitee (€)',
        OWNER_EUR: 'Referrer (€)',
        DEFAULT: 'Default',
        DEFAULT_BONUS: 'Default bonus',
      },
      MODAL: {
        TITLE: 'New invitation link',
        SUBTITLE: 'The link belongs to a specific user: what they and their invitee earn is set here.',
        USER: 'User',
        USER_PLACEHOLDER: 'First name, last name or email',
        MIN_CHARS: 'Type at least two letters to search.',
        SEARCHING: 'Searching...',
        NO_RESULTS: 'No user with that name or email.',
        NOTE: '€0 is a valid amount: it means that party is not paid. The amount is frozen on each redemption, so editing it later does not change what anyone who has already redeemed receives.',
      },
      MESSAGES: {
        INVALID_AMOUNTS: 'Check the amounts: they must be numbers from €0 upwards.',
        BONUS_UPDATED: 'Bonus updated. It applies to new redemptions.',
        LINK_ACTIVATED: 'Link activated.',
        LINK_DEACTIVATED: 'Link deactivated. Redemptions already in progress will continue.',
        COPY_FAILED: 'The link could not be copied.',
        PICK_USER: 'Choose the user the link belongs to.',
        LINK_CREATED: 'Link created. It can now be shared.',
        NO_PERMISSION: 'You do not have permission to manage the referral programme.',
        LOAD_ERROR: 'The data could not be loaded. Please try again.',
      },
      DIAGNOSIS: {
        TAB: 'Referrals',
        TITLE: 'Referrals',
        REFRESH: 'Refresh',
        RETRY: 'Retry',
        LOAD_ERROR: 'Could not load the referrals.',
        DELETED_ON: 'deleted on {{date}}',
        ACTIVE: 'active',
        SAME_PERSON: 'same person',
        OTHER_PERSON: 'another person',
        EARNED_INVITING: 'Earned inviting',
        EARNED_INVITED: 'Earned as invitee',
        PROGRAM: 'Current programme',
        PROGRAM_VALUE: '{{amount}} · {{trips}} trips',
        INVITEE: {
          TITLE: 'How they joined',
          INVITED_BY: 'invited by',
          no_link: { TITLE: 'No link', TEXT: 'did not join through any invitation link' },
          paid: { TITLE: 'Paid', TEXT: 'on {{date}}' },
          pending: {
            TITLE: 'Pending',
            TEXT: 'not paid yet',
            TEXT_VERIFY: 'identity not verified yet',
            TEXT_TRIPS: '{{done}}/{{required}} trips',
          },
          lost_account_deleted: {
            TITLE: 'Lost redemption',
            TEXT: 'the redeeming account was deleted on {{date}}',
            TEXT_NO_DATE: 'the redeeming account is deleted',
          },
          inviter_account_deleted: {
            TITLE: 'Inviter deleted',
            TEXT: 'the inviter deleted their account on {{date}}',
            TEXT_NO_DATE: 'the inviter deleted their account',
          },
          expired: { TITLE: 'Expired', TEXT: 'the redemption expired' },
        },
        INVITER: {
          TITLE: 'Their invitees',
          EMPTY: 'None',
          NO_ACCOUNT: 'No account',
          CAME_BACK: 'Came back with another account:',
          PHONE_OTHER_PERSON: 'Their phone is now used by:',
          OLD_PROGRAM: 'previous programme',
          TIP_NOT_LISTED: 'If they ask about someone who is not listed here, that person did not sign up with their link.',
        },
        STEP: { DELETED: 'Account deleted', LINK: 'Link', REGISTERED: 'Signed up', VERIFIED: 'Verified', TRIPS: 'Trips', PAID: 'Paid', SUB_REJECTED: '{{count}} rejected', SUB_DELETED: 'deleted {{date}}', SUB_NOT_REQUIRED: 'not required' },
        VIEW: { ARIA: 'How to show the invitees', BOARD: 'Board', LIST: 'List' },
        BOARD: { DONE: 'Completed', PROGRESS: 'In progress', OUT: 'Lost' },
        TAG: {
          PAID: 'Paid',
          TRIPS: 'Trips {{done}} of {{required}}',
          LAST_TRIP: 'last {{date}}',
          VERIFY: 'Not verified',
          REJECTED: '{{count}} rejected',
          SIGN_UP: 'Not signed up',
          LINK_ON: 'link {{date}}',
          DELETED: 'Deleted {{date}}',
          DELETED_NO_DATE: 'Account deleted',
          EXPIRED: 'Expired',
        },
        GROUP: { PAID: 'Completed', IN_PROGRESS: 'In progress', LOST: 'Account deleted', EXPIRED: 'Expired' },
        FLAGS: {
          TITLE: 'Warnings',
          OTHER: 'Warning: {{code}}',
          multiple_accounts_same_phone: '{{count}} accounts with their phone',
          dni_in_other_account: 'ID document in {{count}} other accounts',
          phone_used_by_other_person: 'phone used by another person',
          inviter_account_deleted: 'inviter deleted',
        },
      },
    },
  },
};
